import React from 'react';
import cn from 'classnames';

import Button from 'components/Button';
import Modal from '../';
import classes from './modalError.module.scss';
import { IModalError } from './types';

const ModalError: React.FC<IModalError> = ({ 
	className,
	isOpen,
	onClose,
	text,
}) => {
	return (
		<Modal className={cn(classes.modalError, className)} isOpen={isOpen} onClose={onClose}>
			<div className={classes.title}>Ошибка</div>
			<div className={classes.text}>{text}</div>
			<Button className={classes.button} text="OK" onClick={onClose}/>
		</Modal>
	);
};

export default ModalError;
